
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';
import Img from 'theme/components/shared/Img'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "apache-atlas-hook-for-apache-kafka"
    }}>{`Apache Atlas Hook for Apache Kafka`}</h1>
    <h2 {...{
      "id": "kafka-model"
    }}>{`Kafka Model`}</h2>
    <p>{`Kafka model includes the following types:`}</p>
    <ul>
      <li parentName="ul">{`Entity types:`}
        <ul parentName="li">
          <li parentName="ul">{`kafka_topic`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: DataSet`}</li>
              <li parentName="ul">{`attributes: qualifiedName, name, description, owner, topic, uri, partitionCount`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <p>{`Kafka entities are created and de-duped in Atlas using unique attribute qualifiedName, whose value should be formatted as detailed below.
Note that qualifiedName will have topic name in lower case.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
   {`topic.qualifiedName: <topic>@<clusterName>`}
    </SyntaxHighlighter>
    <h2 {...{
      "id": "setup"
    }}>{`Setup`}</h2>
    <p>{`Binary files are present in apache-atlas-`}<release-version />{`-kafka-hook.tar.gz`}</p>
    <p>{`Copy apache-atlas-kafka-hook-`}<release-version />{`/hook/kafka folder to `}<atlas package />{`/hook/    directory`}</p>
    <p>{`Copy apache-atlas-kafka-hook-`}<release-version />{`/hook-bin folder to  `}<atlas package />{`/hook-bin directory`}</p>
    <h2 {...{
      "id": "importing-kafka-metadata"
    }}>{`Importing Kafka Metadata`}</h2>
    <p>{`Apache Atlas provides a command-line utility, import-kafka.sh, to import metadata of Apache Kafka topics into Apache Atlas.
This utility can be used to initialize Apache Atlas with topics present in Apache Kafka.
This utility supports importing metadata of a specific topic or all topics.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`sage 1: <atlas package>/hook-bin/import-kafka.sh
Usage 2: <atlas package>/hook-bin/import-kafka.sh [-t <topic prefix> OR --topic <topic prefix>]
Usage 3: <atlas package>/hook-bin/import-kafka.sh [-f <filename>]
         File Format:
            topic1
            topic2
            topic3`}
    </SyntaxHighlighter>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;